var render = function render(){var _vm=this,_c=_vm._self._c;return _c('select',{staticClass:"select-multiply",attrs:{"autocomplete":"off","multiple":true}},_vm._l((_vm.options),function(option){return _c('option',{key:option.id,domProps:{"value":option.id}},[_vm._v("\n        "+_vm._s(option.name)+"\n    ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }